import Language from '../languageAction/Language';
import Translatable from '../translatable_text/Translatable';
import { Conditional } from '../conditional-render/ConditionalRender';
import { useContext } from 'react';
import { AuthContext } from '@/context/authContext';
import LanguageAction from '../languageAction/LanguageAction';

function Navbar() {

  const { currentUser } = useContext(AuthContext);

  return (
    <>
      <nav className="navbar navbar-expand-lg bord">
        <div className="container w-full flex justify-between items-center">
          <a className="logo icon-img-100" href="/">
            <img style={{ width: 130, marginTop: 0 }} src='/light/assets/imgs/logo/gcadlogo.webp' loading='lazy' alt="logo" width="200px" height="100%" />
          </a>

          <div className="hidden lg:inline" id="navbarSupportedContent">

            <ul className="navbar-nav flex">
              <li className="nav-item">
                <a className="nav-link" href="/" aria-label="Go to home">
                  <span className=''>
                    <Translatable>Home</Translatable>
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" aria-label="Go to service" href="/services">
                  <span>
                    <Translatable>Services</Translatable>
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a aria-label="Go to about us" href="/about" className="nav-link">
                  <span>
                    <Translatable>About</Translatable>
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" aria-label="Go to contact" href="/contact">
                  <span>
                    <Translatable>Contact</Translatable>
                  </span>
                </a>
              </li>
              <Conditional condition={!!currentUser?.email.includes('@gcad')}>
                <li className="nav-item">
                  <a className="nav-link" aria-label="Go to contact" href="/admin/dashboard">
                    <span>
                      <Translatable>Dashboard</Translatable>
                    </span>
                  </a>
                </li>
              </Conditional>
              <li className="nav-item">
                <div className="nav-link">
                  <LanguageAction/>
                </div>
              </li>
            </ul>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
            <div className="topnav white-burger flex items-center justify-center">
              <div className='mobile-lang'>
                <LanguageAction />
              </div>
              <div className="menu-icon cursor-pointer">
                <span className="icon ti-align-right"></span>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="hamenu one-scroll">
        <div className="logo icon-img-100">
          <img src="/light/assets/imgs/logo-light.png" alt="img" />
        </div>
        <div className="close-menu cursor-pointer ti-close"></div>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 lg:col-span-2">
              <div className="menu-text">
                <div className="text">
                  <h2>Menu</h2>
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-7">
              <div className="menu-links">
                  <ul className="ltr:hidden main-menu rest">
                    <li>
                      <div className="o-hidden">
                        <a aria-label="Go to Dashboard" href="/" className="link">
                          <span className="fill-text" data-text="الرئيسية">
                            الرئيسية
                          </span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <a aria-label="Go to services" href="/services" className="link">
                          <span className="fill-text" data-text="الخدمات">
                            الخدمات
                          </span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <a aria-label="Go to contact" href="/contact" className="link">
                          <span className="fill-text" data-text="عن الشركة">
                            عن الشركة
                          </span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <a aria-label="Go to contact" href="/contact" className="link">
                          <span className="fill-text" data-text="تواصل معنا">
                            تواصل معنا
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                  <ul className="rtl:hidden main-menu rest">
                    <li>
                      <div className="o-hidden">
                        <div className="link cursor-pointer dmenu">
                          <a href='/' className="fill-text" data-text="Home">
                            Home
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <div className="link cursor-pointer dmenu">
                          <a href='/services' className="fill-text" data-text="Services">
                            Services
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <div className="link cursor-pointer dmenu">
                          <a href='/about' className="fill-text" data-text="About">
                            About
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="o-hidden">
                        <div className="link cursor-pointer dmenu">
                          <a href='/contact' className="fill-text" data-text="Contact">
                            Contact
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
      
              </div>
            </div>
            <div className="col-span-12 lg:col-span-3">
              <div className={`cont-info rtl:cont-info-sdc-rtl ltr:cont-info-sdc-ltr"}`}>
                <div className="item mb-50">
                  <h2 className="sub-title mb-15 opacity-7">
                    <Translatable>Address</Translatable>
                  </h2>
                  <h5>
                    KSA, <br /> Al Shoqiyah, Mecca 25553
                  </h5>
                </div>
                <div className="item mb-50">
                  <h6 className="sub-title mb-15 opacity-7">
                    <Translatable>Social Media</Translatable>
                  </h6>
                  <ul className="rest social-text">
                    <li className="mb-10">
                      <a href="/" className="hover-this">
                        <span className="hover-anim">Twitter</span>
                      </a>
                    </li>
                    <li className="mb-10">
                      <a href="https://www.linkedin.com/company/gcad-sa/" target='_blank' aria-label='link button' rel="noreferrer" className="hover-this">
                        <span className="hover-anim">LinkedIn</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="item mb-40">
                  <h6 className="sub-title mb-15 opacity-7">
                    <Translatable>Contact Us</Translatable>
                  </h6>
                  <h5>
                    <a href="mailto:co@begining.online" aria-label='email button'>co@begining.online</a>
                  </h5>
                  <h5 className="underline mt-10">
                    <a href="tel:+966595951565" aria-label='call button'>+966 59 595 1565</a>
                  </h5>
                </div>
                <div>
                  <Language/> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
